import getDecryptData from "./getDecryptData";

export const getJobPortalSession = async () => {
  const user = await getDecryptData();

  if (!user?._id) {
    throw new Error("User session not found");
  }

  return user;
};

export const getJobPortalAuthConfig = async () => {
  const user = await getJobPortalSession();
  const authToken = user.token || "";

  return {
    headers: {
      Authorization: authToken ? `Bearer ${authToken}` : "",
      "x-auth-token": authToken,
      "x-auth-user-id": user._id,
    },
  };
};

export const withJobPortalAuth = async (axiosCall) => {
  const config = await getJobPortalAuthConfig();
  return axiosCall(config);
};
